import { API, graphqlOperation } from "aws-amplify";
import { createSensorEventDownloadRequest } from '../../graphql/mutations';

export async function apiCallCreateSensorEventDownloadRequest(downloadRequestInput) {
  const mutationResult = await API.graphql(graphqlOperation(createSensorEventDownloadRequest, {input: downloadRequestInput}));

  return mutationResult;
}
